import { createGenericContext } from "../../../utils/createGenericContext";
export const [SelectedCiRelationTypesContext, useSelectedCiRelationTypesContext] = createGenericContext([]);
